
export const BYPASS_LOADER_KEY = 'bypassLoader';
export const LOADER_DELAY_MS = 800;
export const LOADER_TIMEOUT_MS = 10000;

export const TOAST_VISIBILITY_DURATION = 4000;
